import Section from "../Section/Section";
import Skills from "../../common/Skills";
import SectionTitle from "../../common/SectionTitle";

export default function AllSkills() {
  return (
    <Section id="skills" className="gap-4 w-full">
      <SectionTitle>Tecnologías</SectionTitle>
      <Skills techs />
    </Section>
  );
}
